import { useOutletContext  } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useState, useEffect } from 'react';
import { Pie } from '@ant-design/plots';
import { Card } from 'antd';
import DashboardAPI from "../../restAPI/DashboardAPI";


const DemoPie = ({ isDarkMode }) => {
  const { token } = useSelector(state => state.auth);
  const [pieChartData, setPieChartData] = useState([]);
  const {groupId, companyId} = useOutletContext();

    useEffect(() => {
      getPieChartData();
    }, [groupId, companyId]);

    const getPieChartData = async () => {
      try {
        const res = await DashboardAPI.getDocumentTypeCounts(
          token, 
          localStorage.getItem('groupId'), 
          localStorage.getItem('companyId')
        );
        
        if (res?.data) {
          console.log("pie API Response:", JSON.stringify(res.data));
          
          const dataKeys = Object.keys(res.data || {});
          
          // Map over the keys only if they exist
          const rows = dataKeys.map(k => ({ 

            type: k==="Accounts receivable" ?'Total AR':'Total AP', 
            count:res.data[k] 
          }));
          
          console.log("pie chart rows", rows);
          setPieChartData(rows);
        } else {
          console.log("No data received from API");
          setPieChartData([]); // Set empty array as fallback
        }
      } catch (err) {
        console.log("Error fetching data:", err.message);
        setPieChartData([]); // Set empty array on error
      }
    };


    const config = {
      data: pieChartData.length ? pieChartData : [], // This is the key change
      theme: isDarkMode ? "classicDark" : "classic",
      angleField: 'count',
      colorField: 'type',
      legend: false,
      label: false,
      innerRadius: 0.8,
      height: 250,
      interaction: {
        legendFilter: false
      },
      labels: [
        { text: 'type', style: { fontSize: 10, fontWeight: 'bold' } },
        {
          text: (d, i, data) => (i < data.length - 3 ? d.value : ''),
          style: {
            fontSize: 9,
            dy: 12,
          },
        },
      ],
      style: {
        lineWidth: 0.5,
        inset: 2,
        radius: 8,
      },
      scale: {
        color: {
          offset: (t) => t * 0.8 + 0.1,
          // Dynamic domain based on your data
          domain: pieChartData.length 
            ? [...new Set(pieChartData.map(item => item.type))] 
            : ['Total AR', 'Total AP'],
          range: ['#F28E2B', '#88CCA2'],
        },
      },
      legend: {
        color: {
          itemMarker: 'round',
          itemMarkerSize: 16,
          position: 'right',
          rowPadding: 5,
        },
      },
      annotations: pieChartData.length > 0 ?
      [
        {
          type: 'text',
          style: {
            text: 'Total Documents\n' + (pieChartData.length ? pieChartData.reduce((sum, item) => sum + item.count, 0) : 0),
            x: '50%',
            y: '50%',
            textAlign: 'center',
            pointerEvents: 'none',
            tooltip: false,
            fontSize: 14,
            fontStyle: 'normal',
            fill: isDarkMode ? '#FFFFFF78' : '#00000078',
          },
        },
      ]:[],
    };

  return <Card title="Document Status" style={{ width: '100%' }}><Pie {...config} /></Card>
};

export default DemoPie;